import { create } from 'zustand';

type CorsErrorStore = {
  isOpen: boolean;
  showCorsErrorModal: () => void;
  hideCorsErrorModal: () => void;
};

export const useCorsErrorStore = create<CorsErrorStore>(set => ({
  isOpen: false,
  showCorsErrorModal: () => set({ isOpen: true }),
  hideCorsErrorModal: () => set({ isOpen: false }),
}));
